import React from 'react';
import AnalysisPage from './AnalysisPage'

const AlertAsset = () => {
    const filters = [
        {
            name: "Category",
            type: "dropdown",
            options: ["Health & Safety", "Resource Efficiency", "Service & Maintenance"],
        },
        {
            name: "Asset",
            type: "dropdown",
            options: ["HVAC", "Thermostat", "Water Heater", "Gas Meter", "Water Meter", "Electric Panel"],
        },
        {
            name: "Service",
            type: "button",
        },
        {
            name: "Spend",
            type: "button",
        },
        {
            name: "Degradation",
            type: "button",
        },
        {
            name: "Total Cost",
            type: "button",
        },
        {
            name: "Hourly",
            type: "date",
        },
        {
            name: "Start Date",
            type: "date",
        },
        {
            name: "End Date",
            type: "date",
        },
    ];

    return (
        <AnalysisPage title="Assets" filters={filters}></AnalysisPage>
    )
};

export default AlertAsset;
